/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Component, EventEmitter, Output } from '@angular/core';
import { ShiftElementDirections } from '../../../../../shared/ui/src/lib/enums/shift-segment-directions';

@Component({
  selector: 'sysque-shift-segment',
  templateUrl: './shift-segment.component.html',
  styleUrls: ['./shift-segment.component.scss'],
  standalone: false
})
export class ShiftSegmentComponent {
  @Output() emitShiftValue = new EventEmitter<any>();
  public shiftElementDirections = ShiftElementDirections;

  emitShiftCommand(shiftDirection: ShiftElementDirections) {
    this.emitShiftValue.emit(shiftDirection);
  }
}
